import { repeatedRequest } from './repeatedRequest'

export const iframeHtml = iframe_html => {
  const containerElement = document.getElementById('3ds')
  const isRemoveSupported = typeof containerElement.remove === 'function'

  if (isRemoveSupported) {
    while (containerElement.firstChild) {
      containerElement.firstChild.remove()
    }
  } else {
    while (containerElement.firstChild) {
      containerElement.removeChild(containerElement.firstChild)
    }
  }

  const iframeElement = document.createElement('iframe')
  iframeElement.id = 'new-3ds-iframe'

  iframeElement.setAttribute(
    'sandbox',
    'allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox'
  )

  iframeElement.style.width = '100%'
  iframeElement.style.height = '100%'
  iframeElement.style.position = 'fixed'
  iframeElement.style.zIndex = '99999'
  iframeElement.style.border = 'none'

  containerElement.appendChild(iframeElement)

  const blob = new Blob([iframe_html], { type: 'text/html' })
  const url = URL.createObjectURL(blob)

  iframeElement.src = url

  $('#3ds').show()

  setTimeout(() => {
    repeatedRequest()
  }, 3000)

}
